/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */
import React from 'react'
import { withTranslation } from 'react-i18next'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { Grid } from '@material-ui/core';

import { useThemeData } from '../context/ThemeDataContext'
import { useDownloadData } from '../context/DownloadData'
import GeneralText from "../components/Fonts";

const MuiImageListItem = withStyles({
  root: {
    height: '225px !important', 
    margin: '0 1px'
  },
})(ImageListItem);

function Downloads (props) {
  const {font_family, primary_color_2, background_color_5, primary_color_7, primary_color_6} = useThemeData().themeData.site.theme;
  const {site_id} = useThemeData().themeData.site;
  const {DownloadData, loadingDownload} = useDownloadData();
  const useStyles = makeStyles(() => ({
    icon: {
      color: 'rgb(0 0 0 / 26%)'
    },
    image: {
      border: '1px solid rgb(255, 255, 255)',
      animationName: 'gracefulimage',
      animationDuration: '0.3s',
      animationIterationCount: 1,
      animationTimingFunction: 'ease-in'
    },
    title: {
      color: `${primary_color_7} !important`,
      '&:active': {
        color: `${primary_color_6} !important`,
      },
      '&:hover': {
        color: `${primary_color_6} !important`,
      }
    },
    titleBar: {
      background: 
      'rgba(255, 255, 255, .7)'
    },
  }));
  const classes = useStyles();
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  const PHOTO_URL = process.env.REACT_APP_PHOTO_URL

  const getDownloads = (d) => {
    let link = document.createElement('a')
    link.id = `Download_${String(d.download_id)}`;
    link.href = d.hash
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)
  }

  if (loadingDownload) return <p>{props.t('Loading...')}</p>

  return <Grid item lg={12} md={12}
  style={{
    fontFamily: `${font_family}`,
    color: `${primary_color_2}`
  }}>

      <GeneralText
        variant="h3"
        gutterBottom={true}
      >
        {props.t('navbar:Downloads')}
      </GeneralText>

      <Grid container direction="row" className="download-text mb-2">
        <p>
          {props.t('Download genereren')}
        </p>
      </Grid>
      {!DownloadData ?
      <p>Helaas is er geen download gevonden.</p>
      :
      <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          transitionDuration={500}
          containerClass="carousel-container download-carousel"
          arrows={true}
          deviceType={props.deviceType}
          centerMode={true}
        >

      {DownloadData && DownloadData.map(d => 

          <MuiImageListItem key={d.download_id}>
            <img
              src={`${PHOTO_URL}${site_id}/${d.folder_id}/0/0/0/0/${d.photo_id}/${d.filename}`}
              className={`${classes.image}`}
              alt={d.product_naam}
              // retry={{count: 5, delay: 3, accumulate: 'add'}}
              style={{border: `1px solid ${background_color_5}`}}
            />

            <ImageListItemBar
              title={d.product_naam}
              classes={{
                root: classes.titleBar,
                title: classes.title,
              }}
              subtitle={<span className={classes.title}> {d.product_formaat}</span>}
              actionIcon={
                <IconButton aria-label={props.t('shoppage:Download')} className={classes.icon} name="download" onClick={() => getDownloads(d)}>
                  <CloudDownloadIcon />
                </IconButton>
              }
            />

          </MuiImageListItem>
      
        )}

      </Carousel>
      }
      
</Grid>
}

export default React.memo(withTranslation(['message', 'shoppage', 'navbar'])(Downloads))
